export const Role = {
  Admin: "admin",
  User: "user",
};

const userExists = (user, callback) => {
  return user ? callback() : false;
};

const aclRules = (acl) => {
  // Roles
  acl.rule(Role.Admin, (user) =>
    userExists(user, () => user.roles.some((role) => role === Role.Admin)),
  );
  acl.rule(Role.User, (user) =>
    userExists(user, () => user.roles.some((role) => role === Role.User)),
  );
};

export default aclRules;
